// extracted by mini-css-extract-plugin
module.exports = {"input":"_93444fe79c--input--jnmLf","form":"_93444fe79c--form--CIMR1","controls":"_93444fe79c--controls--JtY_U","button":"_93444fe79c--button--u3Tk6"};